export const FormioConfig = {
  apiUrl: '/'
};
